function initHeaderScrollEffect() {
  $(document).on('scroll',function(e) {
    if(parseInt($(document).scrollTop()) > 150) {
      $('nav.navbar').css('margin-top','0px');
    } else {
      $('nav.navbar').css('margin-top','');
    }
  });

  $(document).trigger('scroll');
}
